/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import AsyncSelect from 'react-select/async'
import type { ValueType, ActionMeta } from 'react-select'

import { IconSearch } from '../Icons'
import Loading from '../Loader'
import Chip from '../Chip'

import { customStyles } from 'components/AutoSuggest/style'

export interface SelectProps {
  placeholder?: string
  selected?: any[] | null
  onChange?: (value: ValueType<any, any>, action: ActionMeta<any>) => void
  disabled?: boolean
  className?: string
  isError?: boolean
  loadOptions?: any
  fullWidth?: boolean
  height?: number
  position?: string
  onBlur?: () => void
}

const IndicatorsContainerCustom = (props: any) => {
  const { isLoading } = props.selectProps

  return (
    <div className='select__indicators-container--top'>
      {isLoading ? <Loading size='sm' /> : <IconSearch variants='sm' />}
    </div>
  )
}

const MultiValueCustom = (props: any) => {
  return (
    <Chip
      className='chip__search__multi'
      onClose={props.removeProps.onClick}
      label={props.data.label}
      data-testid={`chip-${props.data.key}`}
    />
  )
}

function TextInputSearchMulti(props: SelectProps): JSX.Element {
  const {
    loadOptions,
    isError,
    placeholder,
    disabled,
    onChange,
    selected,
    onBlur,
  } = props

  return (
    <AsyncSelect
      classNamePrefix='custom-select-creatable-assign'
      styles={customStyles(props)}
      isMulti
      cacheOptions
      value={selected}
      defaultOptions
      onChange={onChange}
      onBlur={onBlur}
      components={{
        MultiValue: MultiValueCustom,
        IndicatorsContainer: IndicatorsContainerCustom,
        IndicatorSeparator: null,
      }}
      loadOptions={loadOptions}
      isError={isError}
      placeholder={placeholder}
      isDisabled={disabled}
    />
  )
}

export default TextInputSearchMulti
